import React from 'react';
import {  Table,  Button,  Card,  CardTitle} from 'reactstrap';

const AdminPayments = (props) => {  
    return (
        <div >         
            <Card body className="mt-5">
              <div className="tableTitleBg mb-4">
                  <CardTitle className=" " style={{margin: '0'}}>Payments</CardTitle>
              </div>
                <Table responsive hover>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Profile</th>
                        <th>Name</th>
                        <th>Service</th>
                        <th>Total Fee</th>
                        <th>Payment Date</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row">1</th>
                        <td><img className="table-user-img" src="https://images.unsplash.com/photo-1524511858955-5d3bf3afd42e?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=crop&amp;w=634&amp;q=80" alt="Customer avatar" /></td>
                        <td>Ava Sophia</td>
                        <td>Aviation licenses and certifications‎</td>
                        <td> $43</td>
                        <td>12-03-2020</td>
                        <td><Button className="action-btn" color="success"><span className="fas fa-eye"></span></Button>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">2</th>
                        <td><img className="table-user-img" src="https://images.unsplash.com/photo-1524511858955-5d3bf3afd42e?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=crop&amp;w=634&amp;q=80" alt="Customer avatar" /></td>
                        <td>Ava Sophia</td>
                        <td>Aviation licenses and certifications‎</td>
                        <td> $43</td>
                        <td>12-03-2020</td>
                        <td><Button className="action-btn" color="success"><span className="fas fa-eye"></span></Button>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">3</th>
                        <td><img className="table-user-img" src="https://images.unsplash.com/photo-1524511858955-5d3bf3afd42e?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=crop&amp;w=634&amp;q=80" alt="Customer avatar" /></td>
                        <td>Ava Sophia</td>
                        <td>Aviation licenses and certifications‎</td>
                        <td> $43</td>
                        <td>12-03-2020</td>
                        <td><Button className="action-btn" color="success"><span className="fas fa-eye"></span></Button>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
             </Card>         
    </div>
  );
}
export default AdminPayments;
